import React, { createContext, useContext, useRef, useState } from "react";

import { useCheckoutContext } from "@payment/providers/CheckoutProvider/useCheckoutContext";
import { FormHandles } from "@unform/core";

interface IPaymentContext {
  formRef: React.MutableRefObject<FormHandles>;

  openCreditCardForm: boolean;
  setOpenCreditCardForm: React.Dispatch<React.SetStateAction<boolean>>;
}

const PaymentContext = createContext({} as IPaymentContext);

export const PaymentProvider = ({ children }) => {
  const { creditCardState } = useCheckoutContext();

  const formRef = useRef<FormHandles>(null);

  const [openCreditCardForm, setOpenCreditCardForm] = useState<boolean>(
    !creditCardState?.creditCardList?.length,
  );

  return (
    <PaymentContext.Provider
      value={{
        formRef,
        openCreditCardForm,
        setOpenCreditCardForm,
      }}
    >
      {children}
    </PaymentContext.Provider>
  );
};

const usePaymentContext = () => useContext(PaymentContext);

export default usePaymentContext;
